import React, { useEffect, useRef, useState } from "react";
import { friendsmodalProps } from "./friendsmodal-interface";
import { Avatar, Col, Modal, Row } from "antd";
import Learningchart from "../../studentprofilemain/charts/earningchart";
import useRankings from "../../../../../../customhooks/ranking/useRanking";
import { transformAmount } from "../../../../../../utils/helper";
//@ts-ignore
import { useReactToPrint } from "react-to-print";
import moment from "moment";

const loading = false;

const Friendsmodal = ({
  open,
  closeModal,
  studentDetails,
  viewing,
}: friendsmodalProps) => {
  const { loadingRankings, rankings } = useRankings();
  const componentRef = useRef<any>(null);

  const [percentage, setPercentage] = useState(0);
  const [nextRanking, setNextRanking] = useState<any>({});

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `${studentDetails?.firstName}-${
      studentDetails?.lastName
    }-Report-Card-${moment().format("L")}`,
    onAfterPrint: () => {},
  });

  useEffect(() => {
    if (loadingRankings === false && rankings.length !== 0) {
      let currentTotal = 0;
      if (studentDetails?.currentRankId !== undefined) {
        let currentRankingIndex = rankings.findIndex(
          (item: any) => item._id === studentDetails?.currentRankId?._id
        );
        if (currentRankingIndex < rankings.length - 1) {
          setNextRanking(rankings[currentRankingIndex + 1]);
          currentTotal = rankings[currentRankingIndex + 1]?.basePointsRequired;
        } else {
          setNextRanking(rankings[rankings.length - 1]);
          currentTotal = rankings[currentRankingIndex - 1]?.basePointsRequired;
        }
      } else {
        // runInitRanking(rankings[0]);
        setNextRanking(rankings[1]);
      }

      let calculatedPercentage =
        ((studentDetails?.wallet?.funPoints || 0) / currentTotal) * 100;
      setPercentage(calculatedPercentage);
    }

    // eslint-disable-next-line
  }, [loadingRankings, rankings]);

  return (
    <div>
      <Modal
        closable={false}
        open={open}
        onOk={() => {
          if (!loading) {
            closeModal();
          }
        }}
        onCancel={() => {
          if (!loading) {
            closeModal();
          }
        }}
        footer={null}
        width={700}
        className="white-bg-modal"
      >
        <div ref={componentRef}>
          <div className="relative rounded-[30px] bg-appcolorcream p-[1rem]">
            {/* <div className="absolute top-[1rem] right-[0.5rem] cursor-pointer">
							<img src="/img/vectors/aigirl.svg" alt="ai" className='w-[5.1rem] h-[5.6rem]' />
						</div> */}

            <div className="flex">
              <div
                className="relative h-[6.6rem] w-[6rem] rounded-[25px]"
                style={{
                  border: "2px solid #FBE0FF",
                }}
              >
                <img
                  src="/img/vectors/userfemale.svg"
                  alt="userfemale"
                  className="h-full w-full rounded-[25px]"
                />
              </div>

              <div className="ml-2">
                <p className="text-base font-semibold text-appcolorblack">
                  {studentDetails?.firstName ?? "..."}
                </p>
                <p className="mb-2 text-base text-appcolorblack opacity-[0.7]">
                  {studentDetails?.lastName ?? "..."}
                </p>

                <div className="py-[0.3rem]items-center flex justify-between">
                  <span className="text-appcolorblack">
                    {studentDetails?.userName ?? "..."}
                  </span>
                </div>

                <div className="flex mt-2">
                  <div className="custom-white-bg-faint-bg mr-2 flex items-center justify-between rounded-[25px] px-[0.7rem] py-[0.3rem]">
                    <div className="mr-[0.4rem]">
                      <img
                        src="/img/vectors/key.svg"
                        alt="key"
                        className="h-[0.8rem] w-[0.8re,]"
                      />
                    </div>
                    <span className="ml-2 text-appcolorblack">
                      {studentDetails?.wallet?.funKeys ?? 0}
                    </span>
                  </div>

                  <div className="custom-orange-bg-linear-five flex items-center justify-between rounded-[25px] px-[0.7rem] py-[0.3rem] ">
                    <div className="mr-[0.4rem]">
                      <img
                        src="/img/vectors/star.svg"
                        alt="star"
                        className="h-[0.8rem] w-[0.8re,]"
                      />
                    </div>
                    <span className="ml-2 text-appcolorblack">
                      {studentDetails?.wallet?.funPoints ?? 0}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {studentDetails?.currentRankId === undefined ? (
              <p>Ranking not available </p>
            ) : (
              <div className="mt-2">
                <div className="flex items-center ">
                  <div className="mr-[0.6rem]">
                    <img
                      src="/img/vectors/verified.svg"
                      alt="verify"
                      className="w-6 h-6"
                    />
                  </div>

                  <div className="mr-[0.6rem]">
                    <img src="/img/vectors/whitecadet.svg" alt="verify" />
                  </div>

                  <div>
                    <p className="text-[18px] font-medium leading-[107%] text-appcolorblack">
                      {studentDetails?.currentRankId?.rankTitle}
                    </p>
                  </div>
                </div>

                <div className="custom-white-bg-faint relative mt-3 h-[1.5rem] w-full rounded-[30px]">
                  <div
                    className="custom-primary-bg-two flex h-full justify-end rounded-[30px]"
                    style={{
                      width: percentage + "%",
                    }}
                  ></div>

                  <div className="absolute left-[1rem] top-[0.3rem]">
                    <p className="text-sm font-bold text-appcolorwhite ">
                      {transformAmount(
                        nextRanking?.basePointsRequired -
                          studentDetails?.wallet?.funPoints || 0
                      )}
                      fp to {nextRanking?.rankTitle}
                    </p>
                  </div>

                  <div className="absolute right-[1rem] top-[0.3rem]">
                    <p className="text-sm font-bold text-appcolorpurplefaintone ">
                      <span className="text-sm text-appcolorblack">
                        {studentDetails?.wallet?.funPoints ?? 0}
                      </span>
                      /{studentDetails?.currentRankId?.basePointsRequired} fp
                    </p>
                  </div>
                </div>
              </div>
            )}

            {viewing === "student" ? (
              <div className="mt-8">
                <div className="flex items-center justify-between">
                  <div className="flex items-center border-appcolorpurplefaintseven">
                    <p className="mr-2 text-[18px] leading-[107%] text-appcolorblack opacity-[0.5]">
                      Friends
                    </p>
                    <p className="text-[18px] font-bold leading-[107%] text-appcolorblack">
                      0
                    </p>
                  </div>

                  <div className="flex items-center px-4 pl-8 border-x border-appcolorpurplefaintseven">
                    <p className="mr-2 text-[18px] leading-[107%] text-appcolorblack opacity-[0.5]">
                      Mutuals
                    </p>
                    <p className="text-[18px] font-bold leading-[107%] text-appcolorblack">
                      0
                    </p>

                    <div className="px-[2rem]">
                      <Avatar.Group>
                        {[0, 1, 2].map((item) => (
                          <Avatar
                            key={`friend-${item}`}
                            src="/img/vectors/userfemale.svg"
                            style={{
                              border: "2px solid #FBE0FF",
                              borderRadius: "50%",
                              width: "2.1rem",
                              height: "2.1rem",
                            }}
                          />
                        ))}
                      </Avatar.Group>
                    </div>
                  </div>

                  {viewing === "student" ? (
                    <div className="flex items-center">
                      <p className="mr-2 text-[18px] leading-[107%] text-appcolorblack opacity-[0.5]">
                        Friends
                      </p>
                      <div>
                        <img src="/img/vectors/fulladdfriend.svg" alt="flame" />
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            ) : null}

            {viewing === "teacher" ? (
              <div className="flex mt-12">
                <div className="flex justify-between flex-1 pr-5 mr-5 border-r item-center border-appcolorblack">
                  <div className="flex item-center">
                    <span className="pr-1 text-sm font-bold text-appcolorfaintpurplsix">
                      Classes:
                    </span>
                    <span className="text-sm font-medium text-appcolorpurpleeight">
                      {studentDetails?.classes?.length || 0}
                    </span>
                  </div>

                  <img
                    src="/img/vectors/orangemessage.svg"
                    alt="msg"
                    className="w-6 h-6"
                  />
                </div>

                <div className="flex justify-between flex-1 pr-5 mr-5 border-r item-center border-appcolorblack">
                  <div className="flex item-center">
                    <span className="pr-1 text-sm font-bold text-appcolorfaintpurplsix">
                      Message
                    </span>
                  </div>

                  <img
                    src="/img/vectors/orangemessage.svg"
                    alt="msg"
                    className="w-6 h-6"
                  />
                </div>

                <div className="flex justify-between flex-1 item-center">
                  <div
                    className="flex item-center"
                    onClick={() => {
                      handlePrint();
                    }}
                  >
                    <span className="pr-1 text-sm font-bold cursor-pointer text-appcolorfaintpurplsix">
                      Download Report
                    </span>
                  </div>

                  <img
                    src="/img/vectors/orangemessage.svg"
                    alt="msg"
                    className="w-6 h-6"
                  />
                </div>
              </div>
            ) : null}

            {viewing === "teacher" ? (
              <div className="mt-8">
                <Row justify="space-between">
                  <Col xs={24} md={24} lg={8}>
                    <div className="flex items-start">
                      <img
                        src="/img/vectors/purpletimes.svg"
                        alt="purpletimes"
                        className="mr-4"
                      />

                      <div className="flex flex-col">
                        <p className="mb-1 text-sm font-medium text-appcolorfaintpurplefive">
                          Average Test Score
                        </p>

                        <p>
                          <span className="text-2xl font-medium text-appcolorpurpleeight">
                            0
                          </span>
                          <span className="font-medium text-appcolorfaintpurplsix">
                            /100
                          </span>
                        </p>

                        <div className="flex items-center mt-3">
                          {/* <span className='text-xs text-appcolorpurplenine'>
													12%
												</span> */}
                          <img
                            src="/img/vectors/increase.svg"
                            alt="increase"
                            className="px-1"
                          />
                          <span className="text-xs text-appcolorpurplenine">
                            increase
                          </span>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col xs={24} md={24} lg={8}>
                    <div className="flex items-start">
                      <img
                        src="/img/vectors/purpletimes.svg"
                        alt="purpletimes"
                        className="mr-4"
                      />

                      <div className="flex flex-col">
                        <p className="mb-1 text-sm font-medium text-appcolorfaintpurplefive">
                          Passing Rate
                        </p>

                        <p>
                          <span className="text-2xl font-medium text-appcolorpurpleeight">
                            0
                          </span>
                          <span className="font-medium text-appcolorfaintpurplsix">
                            %
                          </span>
                        </p>

                        <div className="flex items-center mt-3">
                          {/* <span className='text-xs text-appcolorpurplenine'>
													12%
												</span> */}
                          <img
                            src="/img/vectors/increase.svg"
                            alt="increase"
                            className="px-1"
                          />
                          <span className="text-xs text-appcolorpurplenine">
                            increase
                          </span>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col xs={24} md={24} lg={8}>
                    <div className="flex items-start">
                      <img
                        src="/img/vectors/purpletimes.svg"
                        alt="purpletimes"
                        className="mr-4"
                      />

                      <div className="flex flex-col">
                        <p className="mb-1 text-sm font-medium text-appcolorfaintpurplefive">
                          Cumulative Points
                        </p>

                        <p>
                          <span className="text-2xl font-medium text-appcolorpurpleeight">
                            {studentDetails?.wallet?.funPoints}
                          </span>
                          <span className="font-medium text-appcolorfaintpurplsix">
                            Fps
                          </span>
                        </p>

                        <div className="flex items-center mt-3">
                          {/* <span className='text-xs text-appcolorpurplenine'>
													12%
												</span> */}
                          <img
                            src="/img/vectors/increase.svg"
                            alt="increase"
                            className="px-1"
                          />
                          <span className="text-xs text-appcolorpurplenine">
                            increase
                          </span>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            ) : null}
          </div>

          <div className="mt-4">
            <div className="custom-black-faint mt-[1rem] flex p-2">
              <div className="flex flex-1 border-r border-appcolorpurplefaintseven">
                <div className="mr-[0.6rem]">
                  <img src="/img/vectors/html.svg" alt="html" />
                </div>

                <div className="mr-[0.6rem]">
                  <img src="/img/vectors/pythonicon.svg" alt="pythonicon" />
                </div>
              </div>

              <div className="flex items-center flex-1 pl-4 border-r border-appcolorpurplefaintseven">
                <div className="pr-[0.6rem]">
                  <img
                    src="/img/vectors/smallpurpletrophy.svg"
                    alt="smalltrophy"
                  />
                </div>

                <div>
                  <p className="text-[20px] leading-[107%] text-appcolorblack">
                    #0
                  </p>
                </div>
              </div>

              <div className="flex flex-1 pl-4">
                <div>
                  <img src="/img/vectors/flame.svg" alt="flame" />
                </div>

                <div className="">
                  <p className="text-[18px] font-bold leading-[107%] text-appcolorblack">
                    {studentDetails?.wallet?.funPoints ?? 0} FP
                  </p>
                  <p className="text-sm text-appcolorblack">This week</p>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-4">
            <p className="font-semibold text-appcolorblack">
              Funpoints This Week
            </p>

            <div className="mt-4 flex rounded-[25px] bg-appcolorwhitefaint px-[1.3rem] py-[1rem]">
              <div className="flex-1 border-r border-appcolorblackdeepone">
                <Learningchart />
              </div>
              <div className="flex flex-col items-center justify-center flex-1">
                <div className="flex mb-4">
                  <div className="mr-1 mt-1 h-[0.5rem] w-[0.5rem] rounded-[3px] bg-appcolorpurplefive"></div>
                  <div>
                    <p className="mb-1 text-base font-semibold mb- text-appcolorblack">
                      Funpoints
                    </p>
                    <p className="text-sm text-appcolorblack">
                      {studentDetails?.wallet?.funPoints ?? 0} FP
                    </p>
                  </div>
                </div>

                {/* <div className='flex'>
									<div className='bg-appcolororangetwo rounded-[3px] h-[0.5rem] w-[0.5rem] mr-1 mt-1'></div>
									<div>
										<p className='mb-1 text-base font-semibold mb- text-appcolorblack'>You</p>
										<p className='text-sm text-appcolorblack'>1327 FP</p>
									</div>
								</div> */}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

Friendsmodal.defaultProps = {
  viewing: "student",
};

export default Friendsmodal;
